import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { UserApi } from 'mvppoker-portal-common/api'
import { useNavigate } from '../../navigation'
import { R } from '../../../R/R'
import { MVPButton } from '../../../Views/Buttons/MVPButton'
import { FullPageHeader } from '../../../Views/FullPageHeader/FullPageHeader'
import { MVPLink } from '../../../Views/Link/MVPLink'
import { MVPTextInput } from '../../../Views/TextInput/MVPTextInput'
import './ForgotPasswordEnterEmailPage.scss'
import { RegisteringUser, setCredentialsAndUser } from '../../../state/reducers/registeringUser'
import { handleError, useApi } from '../../../utils/useApi'
import { ensure } from '../../../utils/EnsureState'
import { Pattern } from '../../../utils/Regex'
import { forgotPasswordEmailChanged } from '../../../state/reducers/activeUser'

type RecoverPasswordFormData = {
	email: string
}

export default () => {
	const form = useForm<RecoverPasswordFormData>()
	const goToNextPage = useNavigate('forgotPasswordEnterCode')
	const dispatch = useDispatch()
	const [isLoading, setLoading] = useState(false)
	const userApi = useApi(UserApi)

	const onSubmit = ({ email }: RecoverPasswordFormData) => {
		setLoading(true)
		dispatch(forgotPasswordEmailChanged(email))
		userApi
			.authUserForgotPassword({ value: email })
			.then(() => goToNextPage())
			.catch((err) => {
				handleError(err)
				setLoading(false)
			})
	}

	return (
		<div id='forgot-password-page' className='stretch-page'>
			<div className='middle-col'>
				<FullPageHeader title='Recover Password' />
				<FormProvider {...form}>
					<form onSubmit={form.handleSubmit(onSubmit)}>
						<span className='prompt'>Please enter your E-mail to get a password reset code sent to your inbox</span>
						<MVPTextInput
							formField='email'
							formValidation={{
								validate: ensure().required().pattern(Pattern.Email, 'Must be a valid email').build(),
							}}
							label='Email'
							placeholder='Enter your email'
							type='email'
						/>
						<MVPButton type='submit' loading={isLoading}>
							Send Reset Code
						</MVPButton>
					</form>
				</FormProvider>
			</div>
		</div>
	)
}
